const GRADS = [
  '#2563eb,#7c3aed', '#059669,#0d9488', '#db2777,#f472b6',
  '#d97706,#fbbf24', '#6366f1,#a78bfa', '#0891b2,#38bdf8',
  '#dc2626,#f97316', '#065f46,#34d399',
];

export const gradFor = (id: number): string => GRADS[id % GRADS.length];

export const initials = (u: { first_name?: string; last_name?: string }): string =>
  `${u.first_name?.[0] ?? ''}${u.last_name?.[0] ?? ''}`.toUpperCase();
